// extracted by mini-css-extract-plugin
export var baseButton = "_vm-0";
export var controlsArrowKeys = "_vm-1";
export var controlsResetButton = "_vm-2";
export var lightGameButton = "_vm-4 _vm-0";
export var playAgainButton = "_vm-5 _vm-0";
export var startGameButton = "_vm-3 _vm-0";